"use strict";
/**
 * 跨端常量与枚举
 * -----------------------------------------------------------------------------
 * **必须与 apps/server/prisma/schema.prisma 中的枚举保持一致。**
 * 修改任一处都要同步另一处（契约一致性由评审把关）。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVOICEABLE_REGISTRATION_STATUSES = exports.McpTokenStatus = exports.MCP_TOKEN_SCOPE_LABEL = exports.McpTokenScope = exports.INVOICE_STATUS_LABEL = exports.InvoiceStatus = exports.InvoiceForm = exports.InvoiceTitleType = exports.OutboxStatus = exports.AssetPurpose = exports.StorageDriver = exports.AuditOperatorType = exports.AdminStatus = exports.NotifyStatus = exports.NotifySmsMode = exports.NotifyChannel = exports.MATERIAL_STATUS_LABEL = exports.MaterialStatus = exports.LogisticsStatus = exports.TransactionStatus = exports.ReconMatchStatus = exports.MatchedBy = exports.KycResult = exports.EntranceGroup = exports.SchemaStatus = exports.EnrollTypeStatus = exports.DeliveryMethod = exports.NotifyEventCode = exports.NotifyLevel = exports.AUTO_RECONCILE_PRIORITIES = exports.ReconPriority = exports.KycStep = exports.BUSINESS_DOMAIN = exports.COURSE_STATUS_LABEL = exports.CourseStatus = exports.TERMINAL_STATUSES = exports.REGISTRATION_STATUS_LABEL = exports.RegistrationStatus = void 0;
exports.isInvoiceableRegistrationStatus = isInvoiceableRegistrationStatus;
/**
 * 报名单状态，流转规则见 docs/02-domain/02-状态机.md
 * ⚠️ C-22（2026-10-15）：**只表述「报名 + 缴费」链路**。
 * 已删除 `MATERIAL_SHIPPED` / `COMPLETED` —— 教材与开课改为**独立维度**（见下方 `CourseStatus`），
 * 发货 / 领取 / 开课 / 结课**均不改变报名单状态**。
 */
exports.RegistrationStatus = {
    DRAFT: 'DRAFT',
    /** 瞬态：核验已在提交前通过，随即自动转入待缴费 */
    SUBMITTED: 'SUBMITTED',
    /** 后台人工驳回，可修改重提（原单，ID 不变） */
    REJECTED: 'REJECTED',
    PENDING_PAYMENT: 'PENDING_PAYMENT',
    /** 报名链路完成的稳定态：缴费核销完成 */
    ENROLLED: 'ENROLLED',
    REFUNDED: 'REFUNDED',
    VOIDED: 'VOIDED',
};
/** 状态中文名（与状态机文档一致，界面文案直接取用） */
exports.REGISTRATION_STATUS_LABEL = {
    DRAFT: '草稿',
    SUBMITTED: '已提交',
    REJECTED: '已驳回',
    PENDING_PAYMENT: '待缴费',
    ENROLLED: '报名成功',
    REFUNDED: '已退费',
    VOIDED: '已作废',
};
/** 终止状态（不可再流转） */
exports.TERMINAL_STATUSES = [
    exports.RegistrationStatus.REFUNDED,
    exports.RegistrationStatus.VOIDED,
];
/**
 * 开课状态 —— **独立维度**（C-22），挂报名单维度。
 * 由管理员单独或批量设置；同一批次内不同学员可以不一样。
 * 与 `Batch` 的开课 / 考试 / 结果发布**时点**是两件事（时点是通知触发基准）。
 * 取值可否决，见 `docs/07-quality/02-完成定义.md` §4.4 推导 D-M。
 */
exports.CourseStatus = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    FINISHED: 'FINISHED',
};
exports.COURSE_STATUS_LABEL = {
    NOT_STARTED: '未开课',
    IN_PROGRESS: '开课中',
    FINISHED: '已结课',
};
/** 业务域（示例数据统一使用；禁用旧业务域词，见 docs/01-scope/03-边界与禁止事项.md） */
exports.BUSINESS_DOMAIN = {
    primary: '营养指导员',
    peers: ['公共营养师', '健康管理师'],
    // 示例字段名。原为「报考等级」，2026-10-30 该字段随价格档位移出表单
    // （价格改由 `EnrollType.basePriceCents` 配置），示例改用仍在表单内的字段。
    fieldName: '文化程度',
    batchName: '2026 秋',
};
/**
 * 核验链步骤（顺序固定，不可调换）
 *
 * ⚠️ **证件照在头像比对之前**（2026-10-20 修订）：比对的两侧是「证件照人像」与
 * 「身份证头像切图」，前者由本链第 ③ 步产出，没它就无从比对。字面量的顺序即
 * 业务顺序，`registration.kyc-gate.ts` 与 `kyc.constants.ts` 按它推进。
 */
exports.KycStep = {
    OCR: 'OCR',
    ID_LOCAL_CHECK: 'ID_LOCAL_CHECK',
    PHOTO_GENERATE: 'PHOTO_GENERATE',
    FACE_MATCH: 'FACE_MATCH',
    /** 提交前准入通过线判定（核验的最后一步；未达标则不允许提交） */
    ADMISSION_CHECK: 'ADMISSION_CHECK',
};
/** 流水匹配优先级，见 docs/02-domain/03-缴费与流水匹配.md §4.2 */
exports.ReconPriority = {
    /** 备注码命中 + 金额一致 → 高置信自动核销 */
    P1: 'P1',
    /** 备注码命中但金额不一致 → 待确认 */
    P2: 'P2',
    /** 备注码未命中 + 金额日期当日唯一 → 待确认 */
    P3: 'P3',
    /** 备注码未命中 + 多候选 → 待确认 */
    P4: 'P4',
    /** 无候选 → 未匹配 */
    P5: 'P5',
    /** 异常（金额无法解析 / 收方账户不符） */
    P6: 'P6',
};
/** 可自动核销的优先级（主路径）。日期不参与高置信判定，故仅 P1 自动核销 */
exports.AUTO_RECONCILE_PRIORITIES = [exports.ReconPriority.P1];
/** 通知级别，见 docs/02-domain/04-通知分级.md */
exports.NotifyLevel = { L1: 'L1', L2: 'L2', L3: 'L3' };
/** 一期通知事件清单（固定 12 类，不得自行增加） */
exports.NotifyEventCode = {
    /** 提交报名成功 · 进入待缴费（已合并原「审核通过 · 待缴费」的通知内容） */
    REGISTRATION_SUBMITTED: 'registration.submitted',
    /** 后台人工驳回 */
    REVIEW_REJECTED: 'review.rejected',
    PAYMENT_REMINDER: 'payment.reminder',
    PAYMENT_RECONCILED: 'payment.reconciled',
    MATERIAL_SUPPLEMENT_REQUIRED: 'material.supplement_required',
    /**
     * 教材领取提醒（2026-10-22 新增，事件清单 12 → 13 类）。
     * 缴费成功（`enrolledAt`）满 **2 天**仍未提交领取申请时触发**一次**，幂等键挂在报名单上。
     * 2 天是学员侧的**后悔期**窗口 —— 窗口内不打扰，窗口过后才催。
     * 超过提醒仍未申请的单不再自动催，由客服按后台「待申请领取」清单人工电话确认。
     */
    MATERIAL_APPLY_REMINDER: 'material.apply_reminder',
    LOGISTICS_SHIPPED: 'logistics.shipped',
    LOGISTICS_ABNORMAL: 'logistics.abnormal',
    INVOICE_ISSUED: 'invoice.issued',
    COURSE_STARTING: 'course.starting',
    EXAM_REMINDER: 'exam.reminder',
    RESULT_PUBLISHED: 'result.published',
    RENEWAL_REMINDER: 'renewal.reminder',
};
/** 履约方式。PICKUP 仅做台账，不进入物流状态机 */
exports.DeliveryMethod = { MAIL: 'MAIL', PICKUP: 'PICKUP' };
// =============================================================================
// 以下枚举与 apps/server/prisma/schema.prisma 一一对应
// -----------------------------------------------------------------------------
// 为什么要在这里再写一遍：`@prisma/client` 是**服务端依赖**，前端（admin / h5）不得引用它，
// 否则会把 Prisma 引擎与其生成物打进浏览器产物。因此契约枚举必须在 shared 里有一份
// 跨端可用的镜像，三端引用同一份。
//
// ⚠️ 两处必须同步修改（契约一致性由评审把关）：
//   apps/server/prisma/schema.prisma  ←→  packages/shared/src/constants.ts
// 注释沿用 schema 内的原文，不另行改写，避免出现两套说法。
// 界面展示文案（中文 label）随页面实现（T-17 / T-18 / T-19）落地，不在此处预先发明。
// =============================================================================
/** 报名类型状态。停用类型不可新建报名，历史数据仍可读 */
exports.EnrollTypeStatus = { ACTIVE: 'ACTIVE', DISABLED: 'DISABLED' };
/** 表单 Schema 状态。已发布版本不可删除，只能归档 */
exports.SchemaStatus = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED',
    ARCHIVED: 'ARCHIVED',
};
/** 入口分组。一期服务台首页使用 GRID（8 项） */
exports.EntranceGroup = { GRID: 'GRID', SERVICE: 'SERVICE', LIST: 'LIST' };
/** 核验结果 */
exports.KycResult = {
    PASS: 'PASS',
    FAIL: 'FAIL',
    /** 服务侧错误（非用户原因），不计入用户重试次数 */
    ERROR: 'ERROR',
};
/** 核销来源：系统自动匹配 or 人工认领 */
exports.MatchedBy = { AUTO: 'AUTO', MANUAL: 'MANUAL' };
/** 核销状态 */
exports.ReconMatchStatus = {
    AUTO_RECONCILED: 'AUTO_RECONCILED', // 已自动核销
    PENDING_CONFIRM: 'PENDING_CONFIRM', // 待人工确认
    ABNORMAL: 'ABNORMAL', // 异常
    UNMATCHED: 'UNMATCHED', // 未匹配
};
/** 流水状态 */
exports.TransactionStatus = {
    PENDING: 'PENDING', // 待处理
    RECONCILED: 'RECONCILED', // 已核销
    CANCELLED: 'CANCELLED', // 已撤销（误核销回退）
    ABNORMAL: 'ABNORMAL', // 异常
};
/** 物流状态。PICKUP（现场领取）仅做台账，不进入本状态机 */
exports.LogisticsStatus = {
    PENDING: 'PENDING',
    SHIPPED: 'SHIPPED',
    IN_TRANSIT: 'IN_TRANSIT',
    SIGNED: 'SIGNED',
    ABNORMAL: 'ABNORMAL',
    RETURNED: 'RETURNED',
    REJECTED: 'REJECTED',
};
/**
 * 教材领取状态 —— **独立列 `Registration.materialStatus`**（2026-10-22 裁决，改写自 C-22）。
 *
 * 与 `RegistrationStatus` 仍**完全解耦**：学员申请领取、登记发货、登记现场领取都**不**改
 * 报名单主状态。区别在于 —— 旧口径「由履约记录派生、不落冗余列」已被推翻：四态里
 * 「待申请领取 → 待发货」这一段**没有履约记录可派生**（学员只是提交了领取意向），
 * 且「发货满 5 个自然日自动确认已领取」需要稳定的起算点与确认时间戳，派生算不出来。
 *
 * 推进链（唯一推进入口 `MaterialStateService.advance`，任何地方不得直写这四列）：
 *   PENDING_APPLY ──学员提交领取──▶ PENDING_SHIP ──后台登记发货──▶ SHIPPED
 *   ──发货满 5 个自然日（0 点结算）──▶ RECEIVED
 *   ABNORMAL 由后台异常登记写入，**不参与**上面这条自动推进链，也不改变报名单主状态。
 *
 * ⚠️ 已删除旧值 `NONE` / `SIGNED` / `PICKED_UP`：`NONE` 即现在的 `PENDING_APPLY`；
 * `SIGNED` 与 `PICKED_UP` 统一并入 `RECEIVED`（一期不接快递平台，签收与现场领取
 * 在学员视角是同一件事 —— 教材到手）。
 */
exports.MaterialStatus = {
    PENDING_APPLY: 'PENDING_APPLY', // 待申请领取（缴费成功即进入）
    PENDING_SHIP: 'PENDING_SHIP', // 待发货（学员已提交领取，等仓库发货）
    SHIPPED: 'SHIPPED', // 已发货（仓库已出库，等 5 个自然日自动确认）
    RECEIVED: 'RECEIVED', // 已领取（自动确认或现场领取登记）
    ABNORMAL: 'ABNORMAL', // 异常（在途异常 / 拒收 / 退回）
};
exports.MATERIAL_STATUS_LABEL = {
    PENDING_APPLY: '待申请领取',
    PENDING_SHIP: '待发货',
    SHIPPED: '已发货',
    RECEIVED: '已领取',
    ABNORMAL: '异常',
};
/** 通知通道 */
exports.NotifyChannel = {
    SMS: 'SMS', // 短信
    MP: 'MP', // 公众号
    SERVICE: 'SERVICE', // 客服消息
    INBOX: 'INBOX', // 服务台消息中心
};
/**
 * 短信的三种模式（2026-10-27 新增，用于后台「通知渠道管理」）。
 *
 * 为什么不是「开/关」两态：L1 与 L2 的真正差别是**强制 vs 兜底**，不是有 vs 无。
 *   - `REQUIRED` 必发 —— 事件一触发就发短信（对应 L1）
 *   - `FALLBACK` 仅兜底 —— 公众号推送失败时才补发（对应 L2 的降级）
 *   - `OFF` 不发
 *
 * 不入库：它不是数据列，只是策略派生出来的一个字段；持久化仍走
 * `SysConfig: notify.policy.<eventCode>` 的 JSON（见 `notify.policy.service.ts`）。
 */
exports.NotifySmsMode = {
    OFF: 'OFF',
    FALLBACK: 'FALLBACK',
    REQUIRED: 'REQUIRED',
};
/** 通知发送状态；终态判定见 docs/04-contracts/领域事件与通知映射.md */
exports.NotifyStatus = {
    PENDING: 'PENDING',
    SENT: 'SENT',
    FAILED: 'FAILED',
    DEGRADED: 'DEGRADED', // 降级发送（L2 转短信）
    SKIPPED: 'SKIPPED', // 命中去重窗口而跳过
};
/** 后台账号状态 */
exports.AdminStatus = { ACTIVE: 'ACTIVE', DISABLED: 'DISABLED' };
/** 审计日志的操作人类型 */
exports.AuditOperatorType = {
    USER: 'USER', // 学员
    ADMIN: 'ADMIN', // 后台账号
    SYSTEM: 'SYSTEM', // 系统
    MCP: 'MCP', // 对外 MCP 接入（Token 归属账号，口径 C-26）
};
/**
 * 存储驱动。一期恒为 LOCAL；OSS / COS 为**预留**（切换驱动只改环境变量与驱动实现，
 * 数据模型与 objectKey 不变）。见 docs/02-domain/07-留存与合规.md §5
 */
exports.StorageDriver = {
    LOCAL: 'LOCAL',
    OSS: 'OSS',
    COS: 'COS',
};
/** 影像资产用途分类 */
exports.AssetPurpose = {
    ID_CARD_FRONT: 'ID_CARD_FRONT', // 身份证正面照（有 OCR 裁剪矫正图时存裁剪图）
    ID_CARD_BACK: 'ID_CARD_BACK', // 身份证国徽面（供应商裁剪矫正图，仅留档，不参与准入判定）
    ID_CARD_AVATAR: 'ID_CARD_AVATAR', // 身份证头像切图（OCR 返回；人脸比对参照图）
    FACE: 'FACE', // 人脸自拍
    ID_PHOTO: 'ID_PHOTO', // 生成的证件照
    ID_PHOTO_ORIGINAL: 'ID_PHOTO_ORIGINAL', // 证件照的源图（手机原始整帧，未经换底；人脸比对用它）
    FORM_ATTACHMENT: 'FORM_ATTACHMENT', // 表单附件（证件照 / 身份证两面 / 学历证书 / 缴费凭证等）
    FORM_SIGNATURE: 'FORM_SIGNATURE', // 表单手写签名（C-23）
    SUPPORT_QRCODE: 'SUPPORT_QRCODE', // 客服码二维码图片（C-10；系统内自维护，不存外链）
};
/** 领域事件发件箱的投递状态 */
exports.OutboxStatus = {
    PENDING: 'PENDING', // 待投递
    PUBLISHED: 'PUBLISHED', // 已投递
    FAILED: 'FAILED', // 投递失败，待重试
    DEAD: 'DEAD', // 超过重试上限，需人工介入
};
/** 发票抬头类型 */
exports.InvoiceTitleType = {
    PERSONAL: 'PERSONAL',
    COMPANY: 'COMPANY',
};
/** 发票形态 */
exports.InvoiceForm = {
    ELECTRONIC: 'ELECTRONIC',
    PAPER: 'PAPER',
};
/**
 * 开票生命周期（口径 C-25，**单表承载**）。
 * `REJECTED` 后可重新申请 —— 因此「同一报名单只开一张票」的约束是
 * **非 REJECTED 唯一**（部分唯一索引），不是整列唯一。
 */
exports.InvoiceStatus = {
    /** 学员已提交申请，等待财务开具 */
    REQUESTED: 'REQUESTED',
    /** 财务已人工开具并登记发票号（触发 `invoice.issued`） */
    ISSUED: 'ISSUED',
    /** 无法开具（带驳回原因），学员可再次申请 */
    REJECTED: 'REJECTED',
};
/** 开票生命周期状态中文名（两端共用，界面文案直接取用） */
exports.INVOICE_STATUS_LABEL = {
    REQUESTED: '待开具',
    ISSUED: '已开具',
    REJECTED: '已驳回',
};
/**
 * 对外 MCP 接入令牌作用域（口径 C-26）。
 * READ 仅只读工具；WRITE 才可调写工具 —— 写工具另有账号权限码第二道闸门。
 */
exports.McpTokenScope = {
    READ: 'READ',
    WRITE: 'WRITE',
};
/** 作用域中文名（后台界面直接取用） */
exports.MCP_TOKEN_SCOPE_LABEL = {
    READ: '只读',
    WRITE: '读写',
};
exports.McpTokenStatus = {
    ACTIVE: 'ACTIVE',
    /** 已吊销：立即失效，不可恢复（需要新凭据就再签一个） */
    REVOKED: 'REVOKED',
};
/**
 * 可申请开票的报名单状态（口径 C-25）—— **只有 `ENROLLED`**。
 *
 * 为什么不是「`ENROLLED` 及之后」：退出该状态的路径只有 `REFUNDED` / `VOIDED`，
 * 两者都意味着**钱已退回或单已作废**，再开票是对不上账的。
 * 草稿 / 待缴费更不该开票（还没付钱）。
 * 因此口径收敛为：**只有「已缴费核销完成」这一稳定态可开票**。
 *
 * 放 `shared` 而不是服务端常量文件：H5 需要**同一条**判定来决定是否渲染申请表单。
 * 各写一处的话，服务端收紧口径后学员端仍会显示一个提交必被拒的表单 ——
 * 这正是「口径必须单一来源」的典型场景（同 `INVOICE_STATUS_LABEL` 的取向）。
 */
exports.INVOICEABLE_REGISTRATION_STATUSES = [
    exports.RegistrationStatus.ENROLLED,
];
/** 该报名单状态是否允许申请 / 登记发票（`INVOICEABLE_REGISTRATION_STATUSES` 的判定入口） */
function isInvoiceableRegistrationStatus(status) {
    return exports.INVOICEABLE_REGISTRATION_STATUSES.includes(status);
}
//# sourceMappingURL=constants.js.map